/**
* reducers for the funds summary
*
* Created by Paul on 7/5/19
*/

import C from '../constants'

const initState = {
    isLoading: false,
    fundsSummaryData: {
        "funds_in_progress": "-",
        "number_of_funds": "-",
        "fua": "-",
        "administrator_type": ""
    },
    fundsListData: []
}

export const fundsSummaryState = (state = initState, action) => {

    switch(action.type) {

        // in case of `isLoading` change
        case C.SET_FUNDS_LIST_LOADER :
            return {
                ...state,
                isLoading: action.payload
            }

        // in case of `fundsSummaryData` change
        case C.SET_FUNDS_SUMMARY_DATA:

            return {
                ...state,
                fundsSummaryData: action.payload
            }

        // in case of `fundsListData` change
        case C.SET_FUNDS_LIST_DATA:

            return {
                ...state,
                fundsListData: action.payload
            }

        default: return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/fundsSummaryReducers.js